import * as types from '../constants/actions';

export function showLoginModal() {
  return (dispatch) => dispatch({ type: types.SHOW_LOGIN_MODAL });
}

export default showLoginModal;

